export function isEventualAction(a) {
    return a && a.isEventualAction;
}
export function eventually(a, options) {
    let subscribers = [];
    const trigger = async (...args) => {
        const result = a(...args);
        trigger.values.unshift(result);
        return Promise.all(subscribers.map(s => s(result)));
    };
    trigger.values = [];
    trigger.doNotUnsubscribeOnExit =
        (options && options.doNotUnsubscribeOnExit) || false;
    trigger.isEventualAction = true; // Force to true primitive type
    trigger.actionCreator = a;
    const doNotSelfDestruct = (options && options.doNotSelfDestruct) || false;
    trigger.subscribe = (fn) => {
        if (trigger.isDead) {
            throw new Error("Cannot subscribe to a dead eventualAction");
        }
        subscribers.push(fn);
        return () => {
            subscribers = subscribers.filter(sub => sub !== fn);
            if (subscribers.length <= 0 && !doNotSelfDestruct) {
                trigger.destroy();
            }
        };
    };
    trigger.isDead = false;
    trigger.destroy = () => {
        trigger.isDead = true;
        subscribers = [];
        trigger.clear();
    };
    trigger.clear = () => {
        trigger.values = [];
    };
    return trigger;
}
//# sourceMappingURL=eventualAction.js.map